import ScreenGame from './components/GameScreen'

/**
 * The quizz screen.
 */
const Screen = ScreenGame
export default Screen
